import TooltipIcon from "./TooltipIcon";

export default TooltipIcon;
